import { BaseRepository } from './BaseRepository';
import { supabase } from '../supabase';

export interface MigrationStatus {
  domain: string;
  legacy_table: string;
  legacy_count: number;
  migrated_count: number;
  migration_complete: boolean;
}

export class MigrationRepository extends BaseRepository<any> {
  constructor() {
    super({ tableName: 'migrations', primaryKey: 'id' });
  }

  /**
   * Check migration status for all domains
   */
  async checkMigrationStatus(): Promise<MigrationStatus[]> {
    const { data, error } = await supabase.rpc('check_migration_status');
    
    if (error) throw error;
    return data || [];
  }
}

export const migrationRepository = new MigrationRepository();
